
import { RouteObject, Navigate } from "react-router-dom";
import loginRoutes from "pages/login/login.routes";
import { lazy } from "react";
import LoginCheck from "pages/login/LoginCheck";
import LoginLayout from "layouts/LoginLayout";
import chatbot from "pages/insights/routes"
import Layout from "pages/insights/Layout";
import ChartLayout from "components/charts/ChartLayout";
import Loadable from "components/Loadable";
import Gallery from "pages/insights/gallery";
import Insights from "pages/insights/insights";
import Home from "pages/insights/home";
import Dashboard from "pages/insights/dashboard";
import Users from "pages/insights/users";

const Threads = Loadable(lazy(() => import("../pages/insights/threads")));
const Insightshub = Loadable(lazy(() => import("../pages/insightshub/Insightshub")));

console.log("Routes loaded");
const routes: RouteObject[] = [
  {
    element: <LoginLayout />,
    children: [...loginRoutes],
  },
  {
    path: '*',
    element: <Navigate to="/" />,
  },
  {
    path:'/',
    element: <Layout />, // This includes the header with icons
    children: [
      { path: '/welcome', element: <Home /> },
      {path: '/insightshub', element: <Insightshub />},
      { path: '/dashboard', element: <Dashboard /> },
      { path: '/insights', element: <Insights />, },
      { path: '/gallery', element: <Gallery /> },
      { path: '/users', element: <Users /> },
      { path: '/threads/', element: <Threads />},
      { path: '/threads/:chatId', element: <Threads /> }
    ],
  },
  {
    path: 'charts',
    element: <ChartLayout />,
  },

];

export const loginRts: RouteObject[] = [
  {
    element: <LoginLayout />,
    children: [...loginRoutes],
  },
  {
    path: '*',
    element: <LoginCheck />,
  }
]

export default routes;